
import { Injectable, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LayoutComponent } from './Module/UI/layout/layout.component';
import { HeaderComponent } from './Module/UI/header/header.component';
import { FooterComponent } from './Module/UI/footer/footer.component';
import { ViewFTERecordsComponent } from './Module/Pages/view-fterecords/view-fterecords.component';
import { FTEDetailsComponent } from './Module/Pages/ftedetails/ftedetails.component';
import { HomeComponent } from './Module/Pages/home/home.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MAT_DATE_LOCALE, NativeDateAdapter, DateAdapter } from '@angular/material/core';
import { DialogModule } from 'primeng/dialog';
import {CommonService } from '../app/Global-Services/common.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import {ConfirmationService} from 'primeng/api';
import { WindowRefService } from '../app/Global-Services/window-ref.service';
import { GlobalVariable } from 'src/app/Variable/global-variable';
import { RouterModule } from '@angular/router';
import { PopUpPartnerActionComponentComponent } from './Module/Pages/pop-up-partner-action-component/pop-up-partner-action-component.component';
import {MatDialogModule} from '@angular/material/dialog';
import { ErrorComponent } from './Module/Pages/error/error.component';
import { LogoutComponent } from './Module/Pages/logout/logout.component';
import { UnAuthorizeComponent } from './Module/Pages/un-authorize/un-authorize.component';
import { LoginComponent } from './Module/Pages/login/login.component';
import { PageNotFoundComponent } from './Module/Pages/page-not-found/page-not-found.component';
import { ExcelUploadService } from '../app/Global-Services/excel-upload.service';
import { AuditTrailPopUpComponent } from './Module/Pages/audit-trail-pop-up/audit-trail-pop-up.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FteFinanceUplodPopUpComponent } from './Module/Pages/fte-finance-uplod-pop-up/fte-finance-uplod-pop-up.component';
import { SortDirective } from './directive/sort.directive';
import { FTERecordsComponent } from './Module/Pages/fterecords/fterecords.component';
import { FteformComponent } from './Module/Pages/fteform/fteform.component';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { CookieService } from 'ngx-cookie-service';
import { AuthGaurdService } from './Global-Services/auth-gaurd.service';
import { HttpClientModule } from '@angular/common/http';
import { HttpRequestInterceptor } from './Global-Services/interceptor.service';
import { TableModule } from 'primeng/table';
import {MatInputModule} from '@angular/material/input';
import {MatSelectModule} from "@angular/material/select";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatMenuModule} from "@angular/material/menu";
import {MatIconModule} from "@angular/material/icon";
import {MatButtonModule} from "@angular/material/button";
import {MatSidenavModule} from "@angular/material/sidenav";
import {MatListModule } from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatSortModule} from '@angular/material/sort';
import {MatRadioModule} from '@angular/material/radio';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCardModule} from '@angular/material/card';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { DropdownModule } from 'primeng/dropdown';
import { AppInsightsService } from './Global-Services/app-insights.service';
import { Idle } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { FteReviewedRecordsComponent } from './Module/Pages/fte-reviewed-records/fte-reviewed-records.component';
import { EmployeeExportComponent } from './Module/Pages/employee-export/employee-export.component';
import { GrantAccessMatrixComponent } from './Module/Access-Matrix/grant-access-matrix/grant-access-matrix.component';
import { BulkUploadAccessMatrixComponent } from './Module/Access-Matrix/bulk-upload-access-matrix/bulk-upload-access-matrix.component';
import { ViewAccessMatrixRecordComponent } from './Module/Access-Matrix/view-access-matrix-record/view-access-matrix-record.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CreateFinanceUserMappingComponent } from './Module/Access-Matrix/create-finance-user-mapping/create-finance-user-mapping.component';
import { ViewFinanceUserMappingComponent } from './Module/Access-Matrix/view-finance-user-mapping/view-finance-user-mapping.component';
import { PopUpAttachRevisedLetterComponent } from './Module/Pages/pop-up-attach-revised-letter/pop-up-attach-revised-letter.component';
import { PopUpReturnRecordStatusChangeComponent } from './Module/Pages/pop-up-return-record-status-change/pop-up-return-record-status-change.component';
import { InitiateRecordsFteComponent } from './Module/Pages/initiate-records-fte/initiate-records-fte.component';


// export const MY_DATE_FORMATS = {
//   parse: {
//     dateInput: { month: 'short', year: 'numeric', day: 'numeric' }
//   },
//   display: {
//     //dateInput: { month: 'short', year: 'numeric', day: 'numeric' },
//     dateInput: 'input',
//     monthYearLabel: { year: 'numeric', month: 'short' },
//     dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
//     monthYearA11yLabel: { year: 'numeric', month: 'long' },
//   }
// };

@Injectable()
export class MyDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: any): string {
    if (displayFormat === 'input') {
      let day = date.getDate();
      let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let monthIndex = date.getMonth();
      let year = date.getFullYear();
      return `${day}-${monthNames[monthIndex]}-${year}`;
    } else {
      let day = date.getDate();
      let monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let monthIndex = date.getMonth();
      let year = date.getFullYear();
      return `${day}-${monthNames[monthIndex]}-${year}`;
    }
  }
};

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    HeaderComponent,
    FooterComponent,
    ViewFTERecordsComponent,
    FTEDetailsComponent,
    HomeComponent,
    PopUpPartnerActionComponentComponent,ErrorComponent,LogoutComponent,UnAuthorizeComponent,
    LoginComponent,PageNotFoundComponent,
    AuditTrailPopUpComponent, FteFinanceUplodPopUpComponent, SortDirective
    , FTERecordsComponent,
    FteformComponent,
    FteFinanceUplodPopUpComponent,
    FteReviewedRecordsComponent,
    EmployeeExportComponent,
    GrantAccessMatrixComponent,
    BulkUploadAccessMatrixComponent,
    ViewAccessMatrixRecordComponent,
    CreateFinanceUserMappingComponent,
    ViewFinanceUserMappingComponent,
    PopUpAttachRevisedLetterComponent,
    PopUpReturnRecordStatusChangeComponent,
    InitiateRecordsFteComponent,
  ],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    DialogModule,
    TableModule,
    MatDatepickerModule, MatNativeDateModule, MatPaginatorModule,MatDialogModule,AutoCompleteModule,MatTableModule,ScrollingModule,
    BsDatepickerModule.forRoot(),
    RouterModule.forRoot([]),
    HttpClientModule,
    MatInputModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatToolbarModule,
        MatMenuModule,
        MatIconModule,
        MatButtonModule,
        MatSidenavModule,
        MatListModule,
        MatTabsModule,
        MatExpansionModule,
        MatGridListModule,
        MatSortModule,
        MatRadioModule,
        MatFormFieldModule,
        MatCardModule,
        MatProgressBarModule,
        DropdownModule,
        NgIdleKeepaliveModule.forRoot(),
        MatCheckboxModule,
        ProgressSpinnerModule
  ],
  providers: [AppTokenHandler,CommonService,HTTPStatus,DatePipe,ConfirmationService,CookieService,AppInsightsService,Idle,
    WindowRefService,GlobalVariable,ExcelUploadService,AuthGaurdService,
     { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
    { provide: DateAdapter, useClass: MyDateAdapter },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
